"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
const _ = __importStar(require("lodash"));
const ApiClientConfigurator_1 = require("../../configuration/ApiClientConfigurator");
const Auth_1 = require("./Auth");
const AuthMethods_1 = require("./AuthMethods");
const AuthTypes_1 = require("./AuthTypes");
class Request {
    constructor(config = {}, opts = {}) {
        this.baseUrl = 'https://api.hubapi.com';
        this.config = config;
        this.opts = opts;
        if (config.basePath) {
            this.baseUrl = config.basePath;
        }
        this.url = this.generateUrl();
        this.method = this.opts.method || 'GET';
        this.headers = Object.assign({}, config.defaultHeaders, this.getDefaultHeaders(), this.opts.headers);
        this.applyAuth();
        this.setBody();
    }
    getSendData() {
        let sendData = {
            method: this.method,
            headers: this.headers,
        };
        if (this.body) {
            sendData = Object.assign(sendData, { body: this.body });
        }
        return sendData;
    }
    getUrl() {
        return this.url;
    }
    applyAuth() {
        const authType = Auth_1.Auth.chooseAuth(this.opts, this.config);
        if (authType) {
            const method = _.get(AuthTypes_1.AuthTypes, authType);
            const value = _.get(this.config, authType);
            if (method === AuthMethods_1.AuthMethods.hapikey) {
                this.url.searchParams.set('hapikey', value);
            }
            if (method === AuthMethods_1.AuthMethods.accessToken) {
                this.headers = Object.assign(this.headers, { Authorization: `Bearer ${value}` });
            }
        }
    }
    getDefaultHeaders() {
        return {
            Accept: 'application/json, */*;q=0.8',
            'User-agent': ApiClientConfigurator_1.ApiClientConfigurator.getUserAgent(),
            'Content-Type': 'application/json',
        };
    }
    generateUrl() {
        let urlStr = this.opts.overlapUrl || this.baseUrl + (this.opts.path || '');
        if (this.opts.qs) {
            const params = new URLSearchParams(this.opts.qs);
            urlStr = `${urlStr}?${params}`;
        }
        return new URL(urlStr);
    }
    setBody() {
        if (this.opts.body) {
            this.body = this.opts.body;
            if (_.get(this.headers, 'Content-Type') === 'application/json' && _.get(this.opts, 'defaultJson', true)) {
                this.body = JSON.stringify(this.body);
            }
        }
    }
}
exports.Request = Request;
//# sourceMappingURL=Request.js.map